/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2024-08-29 21:58:47
 * @LastEditors: yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-06-13 22:09:19
 * @FilePath: \MPC-monorepo\apps\mpc-external\src\containers\OutWorkbench\components\StatementModal.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { Modal } from "@bedrock/components";

type Props = {
    visible?: boolean;
    onOk?: () => void;
    onCancel?: () => void;
}

const StatementModal = (props: Props) => {
    const { visible, onOk, onCancel } = props;
    return (
        <Modal
            width={480}
            visible={visible}
            cancelButton={false}
            title={'《报价声明》'}
            okText={'我同意'}
            onCancel={() => {
                onCancel?.()
            }}
            onOk={() => {
                onOk?.()
            }}
        >
            <p>
            1. 供应商承诺，已充分了解本次合作项目具体内容及网易公司需求，将严格按以上报价执行本次合作，除网易公司另行以书面形式或通过MPC系统确认外，不可自行调整报价单任意金额。合同签署后，如双方确认需上调合同金额，应当另行签署补充协议，否则网易公司无需支付上调后新增合同金额；
            </p>
            <p>
            2. 供应商承诺，将严格保密网易公司未公开的商业信息、产品信息、合作信息等一切涉密信息，恪守双方签署之《商业道德责任书》要求，一旦违反上述约定，网易公司有权单方面终止或解除与供应商的全部或部分合作项目及要求供应商承担违约及赔偿责任，且无需承担任何责任；
            </p>
            <p>
            3.供应商承诺，已充分知晓本次合作项目中网易公司的验收标注与要求，将在上传结案环节中呈现对应的验收内容。已知晓本次合作项目中网易公司提出的必要权益，并确认可以提供当前报价内容中的期望权益。如在后续合作中无法达成上述内容，网易公司有权扣减对应的部分或全部费用。
            </p>
        </Modal>
    )
}

export default StatementModal;



